import { LitState, stateVar } from 'lit-element-state';


class GroupState extends LitState {

  constructor() {
    super();
    this.selectedGroup = stateVar(null);
  }

}

const groupState = new GroupState();

export default groupState;
